import { gql, graphQueryBang } from "shared/lib/graphql"
import { pluralizeStepType } from "shared/lib/utils"

const overviewQuery = gql`
  query partnerAnalyticsOverviewQuery($channelModuleName: String!) {
    simple_service_metrics(channel_module_name: $channelModuleName) {
      channel {
        brand_color
        name
        module_name
        monochrome_image_url
      }
      overview_metrics {
        connected_users
        users_with_enabled_applets
        connected_services
      }
      works_with_metrics {
        works_with_channel {
          brand_color
          name
          module_name
          monochrome_image_url
        }
        users_with_enabled_applets
      }
    }
  }
`

const stepsQuery = (step: string) => gql`
  query partnerAnalyticsStepsQuery($channelModuleName: String!) {
    simple_service_metrics(channel_module_name: $channelModuleName) {
      channel {
        brand_color
      }
      applets_with_service_steps: applets_with_service_${pluralizeStepType(step)}
      users_with_enabled_step_applets: users_with_enabled_${step}_applets
      step_metrics: ${step}_metrics {
        step {
          __typename
          ... on ${step === "query" ? "qwery" : step} {
            name
            module_name
            tier
          }
        }
        users_with_enabled_step_applets
      }
    }
  }
`

export const fetchOverview = (moduleName: string) => graphQueryBang(overviewQuery, { channelModuleName: moduleName })

export const fetchSteps = (step: string, moduleName: string) =>
  graphQueryBang(stepsQuery(step), { channelModuleName: moduleName })
